/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import * as SecureLS from 'secure-ls';
import AppConstant from '../constants/app.constant';

const elevationHistoryKey = 'bn_elevationHistory';
const prefixElevation = 'elevation_';

// Encoding is off
// Compression is on
const ls = new SecureLS({ encodingType: '', isCompression: true });

/**
 * Clear old records if record last used was 30days back
 */
const clearOldElevationRecords = () => {
  const elevationHistory = ls.get(elevationHistoryKey);
  const keysOfHistory = Object.keys(elevationHistory);
  keysOfHistory.forEach((item) => {
    const diffTime = Math.abs(Date.now() - elevationHistory[item].lastUsed);
    const diffInDays = diffTime / (1000 * 60 * 60 * 24);
    if (diffInDays > 30) {
      ls.remove(elevationHistory[item].key);
    }
  });
};

/**
 *
 * @param {string} key
 */
const saveElevationRecordsHistory = (key) => {
  try {
    let elevationHistory = ls.get(elevationHistoryKey);
    if (!elevationHistory) {
      elevationHistory = {};
    }
    if (!elevationHistory[key]) {
      elevationHistory[key] = {
        key,
        lastUsed: Date.now(),
      };
    } else {
      elevationHistory[key].lastUsed = Date.now();
    }
    ls.set(elevationHistoryKey, elevationHistory);
    clearOldElevationRecords();
  } catch (ex) {
    console.log(ex);
  }
};

/**
 *
 * @param {string} key
 */
function getKeyElevation(key) {
  const keyValue = AppConstant.localstorageConf.prefix + prefixElevation + key;
  return keyValue;
}

/**
 * Get data from localstorage and save
 * @param {string} key
 */
const getElevationFromLocalstorage = (key) => {
  const elevationData = ls.get(getKeyElevation(key));
  if (elevationData) {
    saveElevationRecordsHistory(getKeyElevation(key));
  }
  return elevationData;
};

/**
 * Set data to localstorage
 * @param {string} key
 * @param {Object} value
 */
const setElevationToLocalstorage = (key, value) => {
  ls.set(getKeyElevation(key), value);
};

export { getElevationFromLocalstorage, setElevationToLocalstorage };
